<template>
  <div class="custom-filter-input"
       :class="inputStyles">
    <div class="input-header">
      <div>
        <div class="title">
          {{ $t("customContentFilter.wordsAndPhrases") }}
        </div>

        <div class="text">
          {{ $t("customContentFilter.addWordOrPhrase") }}
        </div>
      </div>
      <div class="input-open-btn"
           :class="openBtnStyles"
           @click="showInput">
        <icon-cross width="16"
                    height="16"
                    color="#ffffff"
                    class="btn-plus" />
      </div>
    </div>
    <div v-if="showInputField"
         class="input-field">
      <input v-model="filterText"
             type="text"
             ref="filterInput"
             class="text-field"
             autofocus
             :placeholder="$t('customContentFilter.enterWordOrPhrase')"
             @keyup.enter="onAdd"
             @focus="$emit('focus')"
             @blur="$emit('blur')">

      <div class="btn-cancel" @click="hideInput">
        {{ $t("cancel") }}
      </div>

      <base-button class="btn-add"
                   color="secondary"
                   :disabled="!filterText.trim().length"
                   @click="onAdd">
        <icon-enter iconColor="#000"
                    class="icon-left"
                    width="14"
                    height="14" />
          {{ $t("add") }}
      </base-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      addIconDisabled: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        filterText: '',
        showInputField: false
      }
    },

    methods: {
      onAdd() {
        const text = this.filterText.trim()
        const phrase = text.split(' ')

        if (!text) {
          return
        }

        if (phrase.length > 1) {
          this.$emit('addKeyword', phrase)
          this.filterText = ''

          return
        }

        this.$emit('addKeyword', text)
        this.filterText = ''
      },

      showInput() {
        this.showInputField = true
      },

      hideInput() {
        this.showInputField = false
        this.filterText = ''
      }
    },

    computed: {
      inputStyles() {
        return {
          'custom-filter-input-mobile': this.$mq === 'mobile'
        }
      },

      openBtnStyles() {
        return {
          'input-open-btn-disabled': this.addIconDisabled
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-filter-input {
    margin-bottom: 10px;

    .input-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin: 10px 0 20px 0;

      .title {
        color: map.get($colors, primary);
        font-size: 20px;
      }

      .input-open-btn {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 40px;
        height: 40px;
        min-width: 40px;
        cursor: pointer;

        font-size: 24px;
        background: map.get($colors, primary);
        border-radius: 50%;

        .btn-plus {
          transform: rotate(45deg);
        }
      }

      .input-open-btn-disabled {
        background: rgb(241, 239, 247);
        pointer-events: none;

        .btn-plus {
          color: #3e3e3e;
        }
      }
    }

    .input-field {
      height: 50px;
      background: color.adjust(map.get($colors, primary), $lightness: 40%);
      display: flex;
      align-items: center;
      border-radius: 5px;

      .text-field {
        background: transparent;
        height: 100%;
        width: 50%;

        padding: 0 0 0 32px;
        margin: 0 32px 0 0;
        border: none;
        outline: none;
      }

      .btn-cancel {
        width: 45px;
        height: 18px;
        margin: 0 32px 0 0;
        cursor: pointer;
      }

      .btn-add {
        width: 95px;
        height: 30px;
        font-weight: bold;
        font-size: 14px;
      }
    }
  }

  .custom-filter-input-mobile {


    .input-header {
      margin: 10px 0 10px 0;
    }

    .input-field {
      .text-field {
        margin: 0 10px 0 0;
        padding: 0 0 0 10px;
        width: 100%;
      }

      .btn-cancel {
        width: 50px;
        margin: 0 10px 0 0;
      }

      .btn-add {
        display: none;
      }
    }
  }
</style>
